"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCooperativeLatestImportReport = void 0;
const routes_1 = require("../../routes");
const getCooperativeLatestImportReport = (client) => async (params) => {
    const response = await client.get(routes_1.ENDPOINTS.GET_COOPERATIVE_LATEST_IMPORT_REPORT.applyParams(params));
    return response.data;
};
exports.getCooperativeLatestImportReport = getCooperativeLatestImportReport;
